import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
// import TopNav from "../components/TopNav";
import { Outlet } from "react-router-dom";
import TopNav from "../components/TopNav";

function AuthenticatedLayout({ children }) {
  // const [isCollapsed, setIsCollapsed]=useState(false)
  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="main-content">
        <TopNav />
        <Outlet />
      </main>
    </div>
  );
}

export default AuthenticatedLayout;
